module.exports = __webpack_public_path__ + "static/auto_6-65c76fc5b6e31948ae0f4ec6f99b6519.jpg";